import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import { DocumentStakeholder } from "../../../@types/documentStakeholder";
import axiosInstance from "../../../utils/axiosConfig";

const deleteStakeholder = createAsyncThunk(
  "documentShow/deleteStakeholder",
  async ({ id, order }: DocumentStakeholder, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const signers = state.documentShow.signers;

      const nextStakeholder = signers.filter(({ order: orderItem }) => {
        if (orderItem && order) return orderItem > order;
      });

      for (const stakeholderItem of nextStakeholder) {
        if (stakeholderItem.order)
          await axiosInstance.patch(`${api.baseURL}documentstakeholder/${stakeholderItem.id}`, {
            order: stakeholderItem?.order - 1,
          });
      }

      const response = await axiosInstance.delete(`${api.baseURL}documentstakeholder/${id}`);
      const data: DocumentStakeholder = response.data;

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default deleteStakeholder;
